import { OnboardingOptions } from '@/domain/usecases/onboarding/onboarding-options'
import { importRemote } from '@/main/routes/helpers/loaders'
import { queryClient } from '@/infra/http'

/**
 * Loads onboarding step options for step 1, 3, or 4
 * Fetches options needed for the onboarding step forms
 */
export async function loadOnboardingStepOptions(step: 1 | 3 | 4) {
  const remoteOnboardingOptions = await importRemote<OnboardingOptions>(
    'makeRemoteOnboardingOptions',
    queryClient
  )

  return remoteOnboardingOptions[`getStep${step}`]()
}
